import { Loader2 } from "lucide-react";
import { Progress } from "./progress";

interface ProcessingOverlayProps {
  isProcessing: boolean;
  progress?: number;
  status?: string;
  message?: string;
}

export const ProcessingOverlay = ({
  isProcessing,
  progress,
  status,
  message = "Processing..."
}: ProcessingOverlayProps) => {
  if (!isProcessing) return null;

  return (
    <div className="absolute inset-0 bg-black/50 backdrop-blur-sm z-[9999] flex items-center justify-center">
      <div className="bg-white rounded-lg p-6 max-w-md w-full mx-4 shadow-xl">
        <div className="flex flex-col items-center text-center">
          <div className="relative mb-4">
            <Loader2 className="h-12 w-12 text-digger-blue animate-spin" />
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="h-8 w-8 rounded-full bg-white" />
            </div>
          </div>
          
          <h3 className="text-lg font-semibold mb-2">{message}</h3>
          
          {status && (
            <p className="text-sm text-gray-600 mb-4">{status}</p>
          )}
          
          {progress !== undefined && (
            <div className="w-full">
              <Progress value={progress} className="h-2" />
              <p className="text-xs text-gray-500 mt-2">{Math.round(progress)}%</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}; 